import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "tw-flex tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-sf-slate-lighter-1 tw-bg-white tw-p-6"
};
const _hoisted_2 = {
    class: "tw-flex tw-items-center tw-justify-between tw-gap-4"
};
const _hoisted_3 = {
    class: "tw-m-0 tw-text-base tw-font-medium tw-text-sf-slate-dark-2"
};
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'PanelCard'
    },
    __name: 'panel-card',
    props: {
        title: {}
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "action")
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "default")
            ]);
        };
    }
});
